define(["require", "exports", "tslib", "./ServiceAdapter"], function (require, exports, tslib_1, ServiceAdapter_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.BaseService = void 0;
    var BaseService = (function (_super) {
        (0, tslib_1.__extends)(BaseService, _super);
        function BaseService(channelFlag) {
            return _super.call(this, channelFlag) || this;
        }
        BaseService.prototype.request = function (config) {
            return this.apiService.request(config);
        };
        BaseService.prototype.get = function (url, config) {
            if (config === void 0) { config = {}; }
            return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, this.apiService.get(this.updateConfig(url), config)];
                        case 1: return [2, _a.sent()];
                    }
                });
            });
        };
        BaseService.prototype.post = function (url, data, config) {
            if (config === void 0) { config = {}; }
            return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
                return (0, tslib_1.__generator)(this, function (_a) {
                    return [2, this.apiService.post(this.updateConfig(url), data, config)];
                });
            });
        };
        BaseService.prototype.delete = function (url, config) {
            if (config === void 0) { config = {}; }
            return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
                return (0, tslib_1.__generator)(this, function (_a) {
                    return [2, this.apiService.delete(this.updateConfig(url), config)];
                });
            });
        };
        BaseService.prototype.head = function (url, config) {
            if (config === void 0) { config = {}; }
            return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
                return (0, tslib_1.__generator)(this, function (_a) {
                    return [2, this.apiService.head(this.updateConfig(url), config)];
                });
            });
        };
        BaseService.prototype.put = function (url, data, config) {
            if (config === void 0) { config = {}; }
            return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
                return (0, tslib_1.__generator)(this, function (_a) {
                    return [2, this.apiService.put(this.updateConfig(url), data, config)];
                });
            });
        };
        BaseService.prototype.patch = function (url, data, config) {
            if (config === void 0) { config = {}; }
            return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
                return (0, tslib_1.__generator)(this, function (_a) {
                    return [2, this.apiService.patch(this.updateConfig(url), data, config)];
                });
            });
        };
        return BaseService;
    }(ServiceAdapter_1.ServiceAdapter));
    exports.BaseService = BaseService;
});
//# sourceMappingURL=ServiceBase.js.map